<span class="back-link" (click)="backClicked()">
    <i class="icon" [inlineSVG]="'#chevron_left'"></i>{{ title | translate }}
</span>